import { StatusChip } from '@tap/tap-ui';

export type IStatusFieldViewProps = {
    value: any,
}

export const StatusViewField = ({ value }: IStatusFieldViewProps) => {
    if (!value)
        return <>{'-'}</>;

    return (
        <StatusChip
            styleCode={value.styleCode}
            statusName={value.name}
        />
    );
}